export const awsExports = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_IO0nATmhE",
  USER_POOL_CLIENT_ID: "7jsg15r1bmn5rpuga2kk4o7eu2",
  API_ENDPOINT: "",
};
